module.exports = Object.freeze({
  // ToDo - separate const. Message like this: Message: { statusScheduled: 'scheduled', ...}
  Operators: [
    { id: '23101', name: 'Orange' },
    { id: '23102', name: 'Telekom' },
    { id: '23106', name: 'O2' },
    { id: '23103', name: '4ka' },
  ],
  // message.processing_status - processing on our side (null = scheduled)
  MessageProcessingStatus: {
    scheduled: 'scheduled',
    processed: 'processed',
    failed: 'failed',
    expired: 'expired',
    notEligible: 'not_eligible',
    billingAuthFailed: 'bill_auth_failed',
  },
  // message.delivery_status - outcome reported by provider (null = no outcome yet)
  MessageDeliveryStatus: {
    delivered: 'delivered',
    notDelivered: 'not_delivered',
    notAccepted: 'not_accepted',
    monthlyLimitExceeded: 'limit_exceeded',
    lowCredit: 'low_credit',
    expired: 'expired',
    failed: 'failed',
  },
  // message flags - property of the message (gateway SqlMessage.toJson) => translation key
  MessageFlag: {
    freeMessage: 'flag_free_message',
    imported: 'flag_imported',
    answerToLegacyMsg: 'flag_answer_to_legacy',
    serviceDisabledInfo: 'flag_service_disabled_info',
    serviceVerification: 'flag_service_verification',
    blacklisted: 'flag_blacklisted',
  },
  Service: {
    type_microPayment: 'micropayments',
    type_premium: 'premium',
  },
  Provider: {
    type_microPayment: 'micropayments',
    type_premium: 'premium',
  },
  User: {
    typeAdmin: 'admin',
    typeViewer: 'viewer',
  },
  Share: {
    typePartner: 'partner',
    typeOperator: 'operator',
    variantPrice: 'price',
    variantPercent: 'percent',
    messageTypeVat: 'vat',
    messageTypeMediatexFee: 'mediatex_fee',
    messageTypeMediatexShare: 'mediatex_share',
    messageTypeOperatorFee: 'operator_fee',
    messageTypeOperatorShare: 'operator_share',
    messageTypePartnerFee: 'partner_fee',
    messageTypePartnerShare: 'partner_share',
  },
})